import { useAppSelector } from "../utils/hooks";
import { useTranslateText } from "./useTranslateText";

const CODE_TO_LOCALE: Record<string, string> = {
  ru: "ru-RU",
  en: "en-GB",
  uk: "uk-UA",
  de: "de-DE",
  fr: "fr-FR",
  es: "es-ES",
  ar: "ar",
  tr: "tr-TR",
  zh: "zh-CN",
  ja: "ja-JP",
  ko: "ko-KR",
  pt: "pt-PT",
  hi: "hi-IN",
};

/** Always 24-hour clock — no AM/PM anywhere in the UI. */
export function useTimeFormatOptions() {
  const translate = useTranslateText();
  const code = useAppSelector(
    (state) => state.LanguageTextList?.data?.code || "en",
  );
  const locale = CODE_TO_LOCALE[String(code).toLowerCase()] || "en-GB";

  return {
    translate,
    hour12: false as const,
    locale,
    languageCode: code,
  };
}
